import { useMemo } from 'react';
import { useSimulatorStore } from '../../stores/useSimulatorStore';
import { calculateAllFeatureWTP } from '../../lib/calculations';
import { formatPrice, formatPercent, pnlColorClass } from '../../lib/formatters';
import { InfoButton } from '../common/Tooltip';

export function WTPSummaryTable() {
  const selectedPrice = useSimulatorStore(s => s.selectedPrice);
  const assumptions = useSimulatorStore(s => s.assumptions);
  const data = useMemo(() => calculateAllFeatureWTP(selectedPrice, assumptions), [selectedPrice, assumptions]);

  return (
    <div className="card">
      <div className="flex items-center gap-2 mb-1">
        <h3 className="text-heading font-semibold text-secondary uppercase tracking-wider">WTP Summary</h3>
        <InfoButton helpKey="wtpSummary" size={13} />
      </div>
      <p className="text-sm text-muted mb-4">Feature value ranked by implied dollar amount at {formatPrice(selectedPrice)}. Net Value = WTP minus COGS.</p>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-secondary">
              <th className="text-left py-2 px-3 font-medium">#</th>
              <th className="text-left py-2 px-3 font-medium">Feature</th>
              <th className="text-right py-2 px-3 font-medium">Lift</th>
              <th className="text-right py-2 px-3 font-medium">WTP</th>
              <th className="text-right py-2 px-3 font-medium">COGS</th>
              <th className="text-right py-2 px-3 font-medium">Net Value</th>
            </tr>
          </thead>
          <tbody>
            {data.map(row => {
              const cogs = assumptions.featureCosts?.[row.name] ?? 0;
              const netValue = Math.round(row.impliedDollarValue) - cogs;
              return (
                <tr key={row.name} className="border-b border-border/50 transition-colors"
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = 'var(--color-hover-bg)'}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}>
                  <td className="py-2.5 px-3 font-mono text-muted">{row.rank}</td>
                  <td className="py-2.5 px-3 text-primary font-medium">{row.name}</td>
                  <td className="py-2.5 px-3 text-right font-mono text-secondary">+{formatPercent(row.lift)}</td>
                  <td className="py-2.5 px-3 text-right font-mono text-chart-teal font-semibold">
                    {formatPrice(Math.round(row.impliedDollarValue))}
                  </td>
                  <td className="py-2.5 px-3 text-right font-mono text-muted">
                    {formatPrice(cogs)}
                  </td>
                  <td className={`py-2.5 px-3 text-right font-mono font-bold ${pnlColorClass(netValue)}`}>
                    {netValue >= 0 ? '+' : ''}{formatPrice(netValue)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
